module.exports = __webpack_public_path__ + "static/pic01-2a860d26c7b8e24f689678054c53776c.jpg";